<template>
  <b-overlay :show="loading" rounded="sm">
    <b-card class="message-group-item">
      <h4 v-text="editing ? $t('prizeWheel.edit') : $t('prizeWheel.add')" class="mb-2" />
      <div class="text-center">
        <img src="@/assets/images/pages/spinner.jpg">
      </div>
      <b-row>
        <b-col md="12" lg="8" offset-lg="2">
          <b-row>
            <b-col md="6">
              <b-form-group :label="$t('common.title')" label-for="Title">
                <b-form-input v-model="form.Title" autocomplete="off" />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group :label="$t('common.description')" label-for="Description">
                <b-form-textarea
                    v-model="form.Description"
                    autocomplete="off"
                    rows="4"
                    no-resize
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" class="mb-1 mt-1">
              <fm-file-select v-model="form.BackgroundImage" :label="$t('prizeWheel.backgroundImage')" :entity="1" />
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('prizeWheel.targetUsers')" label-for="segment">
                <segment-select v-model="form.SegmentId" autocomplete="off" :multiple="false" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                  :label="$t('common.startDate')"
                  label-for="StartDate"
              >
                <date-picker v-model="form.StartDate" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                  :label="$t('common.endDate')"
                  label-for="EndDate"
              >
                <date-picker v-model="form.EndDate"/>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('prizeWheel.wheelSliceCount')" label-for="wheelSliceCount">
                <b-form-input v-model="form.WheelSliceCount" autocomplete="off" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('prizeWheel.userChanceCount')" label-for="userChanceCount">
                <b-form-input v-model="form.UserChanceCount" autocomplete="off" />
              </b-form-group>
            </b-col>
<!--            <b-col md="4">-->
<!--              <b-form-group-->
<!--                  :label="$t('prizeWheel.twoClickInterval')"-->
<!--                  label-for="TwoClickInterval"-->
<!--              >-->
<!--                <date-picker type="time" v-model="form.TwoClickInterval" input-format="HH:mm" display-format="HH:mm" />-->
<!--              </b-form-group>-->
<!--            </b-col>-->
            <b-col md="6">
              <b-form-group class="mt-2 mb-3">
                <b-form-checkbox
                    v-model="form.Deactive"
                    name="Deactive"
                    value="true"
                    class="custom-control-danger"
                >
                  {{ $t('common.deactive') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col cols="12" class="mt-2">
              <p class="mb-1 font-medium-3" v-text="$t('prizeWheel.prizes')" />
              <div v-for="(item, index) in form.Prize" :key="index">
                <div class="d-flex">
                  <b-row class="mr-1 w-100">
                    <b-col md="4">
                      <b-form-group :label="$t('prizeWheel.prizeType')" label-for="type">
                        <v-select
                            v-model="item.PrizeType"
                            dir="rtl"
                            :reduce="x => x.value"
                            label="text"
                            input-id="Type"
                            :clearable="false"
                            :options="enums('prizeType')"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col   md="4">
                      <b-form-group :label="$t('common.title')" label-for="PrizeName">
                        <b-form-input v-model="item.PrizeName" autocomplete="off" />
                      </b-form-group>
                    </b-col>
                    <b-col   md="4">
                      <b-form-group :label="$t('prizeWheel.ratio')" label-for="ratio">
                        <b-form-input v-model="item.Ratio" autocomplete="off" />
                      </b-form-group>
                    </b-col>
                    <b-col   md="4">
                      <b-form-group :label="$t('prizeWheel.quantity')" label-for="quantity">
                        <b-form-input v-model="item.Quantity" autocomplete="off" />
                      </b-form-group>
                    </b-col>
                    <b-col v-if="prizeType(item.PrizeType) === 'Coupon'" md="4">
                      <b-form-group :label="$t('common.coupon')" label-for="coupon">
                        <coupon-select v-model="item.CouponId" autocomplete="off" :multiple="false" />
                      </b-form-group>
                    </b-col>
                    <b-col v-if="prizeType(item.PrizeType) === 'Activity'" md="4">
                      <b-form-group :label="$t('prizeWheel.activityPackage')" label-for="activityPackage">
                        <activity-group v-model="item.ActivityPackageId" autocomplete="off" :multiple="false" />
                      </b-form-group>
                    </b-col>
                    <b-col v-if="prizeType(item.PrizeType) === 'Diet'" md="4">
                      <b-form-group :label="$t('common.diet')" label-for="diet">
                        <diet-duration-price-select v-model="item.DietDurationPriceId" autocomplete="off" :multiple="false" />
                      </b-form-group>
                    </b-col>
                      <b-col md="4">
                      <b-form-group :label="$t('common.Order')" label-for="diet">
                        <b-form-input v-model="item.Order" autocomplete="off" />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <div class="d-flex align-items-center">
                    <b-button
                        v-show="form.Prize.length > 1"
                        variant="danger"
                        class="btn-icon"
                        size="sm"
                        @click="deletePrize(index)"
                    >
                      <feather-icon icon="Trash2Icon" />
                    </b-button>
                  </div>
                </div>
                <hr />
              </div>
              <b-button variant="primary" @click="addPrize">
                {{ $t('common.add') }}
              </b-button>
            </b-col>
          </b-row>
          <div class="d-flex align-items-center justify-content-center mt-4">
            <b-button variant="primary" class="mr-1" @click="submit">
              {{ $t('common.save') }}
            </b-button>
            <b-button :to="{ name: 'prizeWheels'}">
              {{ $t('common.back') }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import FmFileSelect from "@/views/menu/file-manager/components/fmFileSelect.vue";
import segmentSelect from "@/tools/segmentSelect.vue";
import CouponSelect from '@/tools/coupon.vue'
import ActivityPackageSelect from '@/tools/activitypackage.vue'
import DietDurationPriceSelect from '@/tools/dietDurationPrice.vue'
import ActivityGroup from "@/tools/activitygroup.vue";
export default {
  name: "PrizeWheelForm",
  components: {ActivityGroup, FmFileSelect, CouponSelect, segmentSelect, ActivityPackageSelect, DietDurationPriceSelect },
  data() {
    return {
      loading: false,
      form: {
        Title: '',
        Description: '',
        BackgroundImage: '',
        WheelSliceCount: '',
        StartDate: '',
        EndDate: '',
        TwoClickInterval: '00:00',
        UserChanceCount: '',
        Deactive: false,
        SegmentId: '',
        Prize: []
      },
      prize: {
        PrizeType: 0,
        CouponId: '',
        ActivityPackageId: '',
        DietDurationPriceId: '',
        PrizeName: '',
        Ratio: '',
        Quantity: '',
      }
    }
  },
  computed: {
    editing() {
      return this.$route.params.id
    }
  },
  watch: {
    editing: {
      immediate: true,
      handler(val) {
        if (val !== '' && val !== undefined) this.getData()
        else this.addPrize()
      }
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.$http.get(this.$api.prizeWheel.get, { params: { Id: this.editing } })
          .then(res => {
            this.loading = false
            this.fillForm(res.data)
          }).catch(() => {
        this.loading = false
      })
    },
    submit() {
      this.loading = true

      let data = { ...this.form }

      let url = this.editing
          ? this.$api.prizeWheel.edit
          : this.$api.prizeWheel.add

      if (this.editing) data.id = this.editing

      this.$http.post(url, data)
          .then(() => {
            this.loading = false
            this.$router.back()
          }).catch(() => {
        this.loading = false
      })
    },
    addPrize() {
      this.form.Prize.push({ ...this.prize })
    },
    deletePrize(index) {
      this.form.Prize.splice(index, 1)
    },
    fillForm(data) {
      this.form.Title = data.Title
      this.form.Description = data.Description
      this.form.BackgroundImage = data.BackgroundImage
      this.form.WheelSliceCount = data.WheelSliceCount
      this.form.TwoClickInterval = data.TwoClickInterval
      this.form.UserChanceCount = data.UserChanceCount
      this.form.Deactive = data.Deactive
      this.form.SegmentId = data.SegmentId
      this.form.StartDate = data.StartDate
      this.form.EndDate = data.EndDate
      this.form.Prize = data.Prize.map(item => {
        return {
          PrizeType: item.PrizeType,
          CouponId: item.CouponId,
          ActivityPackageId: item.ActivityPackageId,
          DietDurationPriceId: item.DietDurationPriceId,
          PrizeName: item.PrizeName,
          Ratio: item.Ratio,
          Quantity: item.Quantity,
          Order: item.Order
        }
      })
    },
    prizeType(type) {
      return this.enums('prizeType','value', type,'key') || ''
    }
  }
}
</script>